/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Box, Button, Chip, Typography, paletteColors } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

export const AppointmentWipContentPartial = (): JSX.Element => {
    const { formatMessage } = useIntl();

    return (
        <Box
            data-spec-id="agenda-rdv-wip-card"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                gap: 2,
                p: 4,
            }}
        >
            <Chip
                label={formatMessage({ id: 'appointment.rdv.wip_badge' })}
                sx={{
                    bgcolor: paletteColors.blue[100],
                    color: paletteColors.blue[800],
                    fontWeight: 700,
                }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {formatMessage({ id: 'appointment.rdv.wip_title' })}
            </Typography>
            <Button
                data-spec-id="agenda-rdv-notify-button"
                variant="contained"
                onClick={() => {
                    // @todo amplitude: track rdv_wip_notify_clicked once event is defined in Amplitude schema
                }}
            >
                {formatMessage({ id: 'appointment.rdv.notify_button' })}
            </Button>
        </Box>
    );
};
